<!-- eslint-disable -->
<template lang="pug">
    .rating-banner
        .rating-banner__header
            .header__item {{ $i18n.t('dashboard.dashboard_battle_rating_header') }}
        divider.rating-banner__divider(:margin="'0 auto'")
        .rating-banner__body(v-if="!isLoading")
            .rating-banner__places(v-if="!isLoading && canShowPlaces")
                .rating-banner__place
                    svg-icon.rating-banner__icon.rating-banner__world(name="geolocalization" size="xx-large")
                    div {{ $i18n.t('dashboard.dashboard_rating_world') }}
                    .rating-banner__position
                        i.fa.fa-trophy(v-if="rating.systemPlace < 4", :class="getColor(rating.systemPlace)")
                        | {{ getPositionFor(rating.systemPlace) }}
                .rating-banner__place
                    svg-icon.rating-banner__icon.rating-banner__school(name="admission" size="xx-large")
                    div {{ $i18n.t('dashboard.dashboard_rating_school') }}
                    .rating-banner__position
                        i.fa.fa-trophy(v-if="rating.schoolPlace < 4", :class="getColor(rating.schoolPlace)")
                        | {{ getPositionFor(rating.schoolPlace) }}
                .rating-banner__place
                    svg-icon.rating-banner__icon.rating-banner__grade(name="reward" size="xx-large")
                    div {{ $i18n.t('dashboard.dashboard_rating_grade') }}
                    .rating-banner__position
                        i.fa.fa-trophy(v-if="rating.gradePlace < 4", :class="getColor(rating.gradePlace)")
                        | {{ getPositionFor(rating.gradePlace) }}
            .rating-banner__empty(v-else)
                | {{ phrase }}
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import RatingApi from '../../../api/rating.js';
    import _ from 'lodash';
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                phrase: this.$i18n.t('dashboard.dashboard_rating_noStars'),
                rating: null,
                canShowPlaces: false,
                isLoading: false,
            };
        },
        computed: {
            ...mapState({
                course: state => state.trainer.course,
            }),
        },
        mounted() {
            this.getBattleRating();
        },
        methods: {
            getColor(place) {
                return {
                    gold: place === 1,
                    silver: place === 2,
                    copper: place === 3,
                };
            },
            getBattleRating() {
                this.isLoading = true;
                RatingApi.show(this.date, { forBattle: 1, course_type: _.kebabCase(this.course) })
                    .then(rating => {
                        this.rating = rating;
                        if (this.rating.systemPlace) {
                            this.canShowPlaces = true;
                        }
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            getPositionFor(place) {
                return place <= 500 ? place : '500+';
            },
        },
    };
</script>

<style lang="scss" scoped>
    $gold: #ffad1f;
    $silver: #858585;
    $copper: #a44020;

    .gold {
        color: $gold;
    }
    .silver {
        color: $silver;
    }
    .copper {
        color: $copper;
    }

    .rating-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .rating-banner__header {
        margin: 30px 0 25px 30px;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .rating-banner__body {
        margin: 20px 30px 25px 30px;
        font-size: 16px;
        line-height: 24px;
    }

    .rating-banner__course {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;

        margin-bottom: 25px;
    }

    .rating-banner__divider {
        width: calc(100% - 60px) !important;
    }

    .rating-banner__empty {
        font-size: 16px;
        line-height: 19px;
    }

    .rating-banner__empty-icon {
        color: $hsl-color-gray-74;
        font-size: 30px;
        padding-bottom: 10px;
    }

    .header__item--date {
        padding-top: 25px;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
    }

    .rating-banner__places {
        display: flex;
        justify-content: space-between;
    }

    .rating-banner__place {
        display: flex;
        flex-direction: column;
        align-items: center;

        font-size: 16px;
        line-height: 19px;
    }

    .rating-banner__position {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $hsl-color-green-58;

        margin-top: 10px;

        i {
            margin-right: 5px;
        }
    }

    .rating-banner__icon {
        margin-bottom: 10px;
    }

    .rating-banner__world {
        color: $hsl-color-yellow-66;
    }

    .rating-banner__school {
        color: $x-color-orange;
    }

    .rating-banner__grade {
        color: $hsl-color-blue-56;
    }
</style>
